export default "__VITE_ASSET__DPRhPW1K__"